import intl from '../../locale';
import { PluralMessages } from './FormattedPlural';

export function formatPlural({ value, index }: { value: number; index: string }) {
  const { One = {}, Few = {}, Many = {}, Other = {} } = PluralMessages[index] ?? {};
  // TODO: определить нужно ли исправить слов в множественной форме
  // eslint-disable-next-line @typescript-eslint/switch-exhaustiveness-check
  switch (intl.formatPlural(value)) {
    case 'one':
      return intl.formatMessage(One);
    case 'few':
      return intl.formatMessage(Few);
    case 'many':
      return intl.formatMessage(Many);
    case 'other':
      return intl.formatMessage(Other);
  }
}
